export const TableAndTicketsFormStyle = {
  wrapper: {
    display: 'flex',
    gap: '24px',
    marginBottom: '24px',
    justifyContent: 'space-between',
    '@media (max-width: 1023.98px)': {
      flexDirection: 'column',
      gap: '12px',
    },
    '@media (max-width: 639.98px)': {
      gap: '20px',
      marginBottom: '20px',
    },
  },

  title: {
    marginBottom: '16px',
  },

  titleTable: {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    marginBottom: '16px',
  },

  date: {
    display: 'flex',
    gap: '12px',
    alignItems: 'center',
    '@media (max-width: 639.98px)': {
      flexDirection: 'column',
      alignItems: 'stretch',
    },
  },

  dateMonthYear: {
    '.MuiInputBase-root': {paddingRight: '0px !important'},
    '.MuiInputBase-input': {padding: '0 0 0 6px !important'},
    '@media (max-width: 639.98px)': {
      maxWidth: '100%',
      width: '100%',
    },
  },

  time: {
    '& > div:first-of-type': {maxWidth: '120px', width: '120px'},
    '@media (max-width: 639.98px)': {
      '& > div:first-of-type': {maxWidth: '100%', width: '100%'},
    },
  },
  content: {
    display: 'grid',

    gridTemplateColumns: '2fr 1fr 1fr 1fr 1fr 20px',
    gap: '12px',
    alignItems: 'end',

    '@media (max-width: 1023.98px)': {
      gridTemplateColumns: '1.9fr 1fr 1fr 1fr 1fr 20px',
    },
  },

  titleTickets: {
    marginBottom: '16px',
    textAlign: 'center',
  },

  ticketsTier: {
    maxWidth: '100%',
    '@media (max-width: 1023.98px)': {
      width: '100%',
    },
  },

  price: {
    '& .MuiInputBase-input': {
      padding: '0 12px 0 0 !important',

      '@media (max-width: 1023.98px)': {
        padding: '0 12px  !important',
      },
    },
  },

  button: {
    padding: '10px 0px',
  },

  text: {
    color: 'var(--neutral-300)',
    fontStyle: 'italic',
    fontSize: '12px',
  },

  coverFeeTooltip: {
    display: 'flex',

    '& svg': {
      width: '16px',
      height: '16px',
      '& path': {fill: 'var(--neutral-300)'},
    },
  },

  textWithTooltip: {
    display: 'flex',
    gap: '4px',
    alignItems: 'center',
  },

  tree: {
    width: '100%',
    'li ul li .MuiTreeItem-content .MuiTreeItem-label': {padding: '0', borderRadius: '8px', a: {borderRadius: '8px'}},

    '.MuiTreeItem-content': {
      position: 'relative',
      width: '100%',
      borderRadius: '8px',
      padding: 0,
      background: 'none',

      '&.Mui-focused.Mui-selected, &.Mui-selected, &.Mui-selected:hover, &:hover': {
        background: 'none',
      },

      '.MuiTreeItem-label': {
        color: 'var(--neutral-700)',
        padding: '8px 0',
        borderRadius: '8px',
        paddingLeft: 0,

        '.MuiBox-root': {
          display: 'flex',
          gap: '10px',
        },
        a: {
          padding: '10px 5px',
          width: '100%',
          height: '100%',
        },
      },

      '.MuiTreeItem-iconContainer': {
        // position: 'absolute',
        width: '14px',
      },
    },

    '.Mui-selected.Mui-focused': {
      background: 'none',
    },

    '.MuiCollapse-root': {
      position: 'relative',

      '.MuiTreeItem-content': {
        background: 'none',
        '&:hover': {
          background: 'none',
        },
      },

      '.MuiTreeItem-label': {
        position: 'relative',
        background: 'none',
      },

      '.Mui-selected .MuiTreeItem-label': {
        color: 'var(--primary-500)',
        borderRadius: '8px',
      },
    },
  },
  arrowTop: {
    transform: 'rotate(180deg)',
  },
  disabledIcon: {
    svg: {
      '& path': {
        fill: 'var(--neutral-300)',
      },
    },
  },

  menuItem: {
    width: '100%',
    padding: '8px 16px',
    cursor: 'pointer',

    '&:hover': {
      backgroundColor: 'var(--background-grey-op-50-1)',
    },
  },

  disabledMenuItem: {
    color: 'var(--neutral-300)',
    cursor: 'default',
  },
};
